/**
 * MLB player headshot URLs under picks-core/mlb/headshots/{TEAM}/{first_last}.png
 * Mirrors the MLB branch of apps/daily-reveal/src/utils/playerHeadshot.ts
 */
const STORAGE_ACCOUNT = import.meta.env.VITE_BLOB_STORAGE_ACCOUNT_NAME || 'draftkingsdev';
const CONTAINER = import.meta.env.VITE_BLOB_STORAGE_CONTAINER || 'picks-core';
const CDN_BASE_URL = `https://${STORAGE_ACCOUNT}.blob.core.windows.net/${CONTAINER}`;

const MLB_TEAM_ABBR_MAP: Record<string, string> = {
  AZ: 'ARI',
  ANA: 'LAA',
};

export function generateMLBHeadshotUrl(
  teamAbbr: string,
  firstName: string,
  lastName: string
): string {
  const folder = MLB_TEAM_ABBR_MAP[teamAbbr] || teamAbbr;
  const normalize = (s: string) => s.toLowerCase().replace(/\./g, '_').replace(/\s+/g, '_');
  return `${CDN_BASE_URL}/mlb/headshots/${folder}/${normalize(firstName)}_${normalize(lastName)}.png`;
}
